import React from "react"
import { graphql } from "gatsby"
import { Helmet } from "react-helmet"
import Img from "gatsby-image"
import YoutubeVideo from "../../components/YoutubeVideo";
import ChallengeForm from "../../components/ChallengeForm";
import PersonList from "../../components/PersonList";
import Markdown from "../../components/Markdown"
import config from "../../config/config";

import style from "./index.module.css";

export default class Challenge extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      formSuccess: false,
      challengeActive: true,
    };
  }

  handleFormSuccess() {
    this.setState({
      formSuccess: true,
    })
  }

  render() {
    const pageContent = this.props.data.page
    const image = (pageContent.imageActive && pageContent.image) ? pageContent.image : false;
    const video = (pageContent.videoActive && pageContent.video) ? pageContent.video : false;
    const dateNow = new Date();
    const dateChallengeOpen = new Date(config.challengeOpen);
    const dateChallengeClosed = new Date(config.challengeClosed);
    //const dateVotingOpen = new Date(config.votingOpen);
    //const dateVotingClosed = new Date(config.votingClosed);
    const challengeActive = (dateNow > dateChallengeOpen) && (dateNow < dateChallengeClosed);
    //const votingActive = (dateNow > dateVotingOpen) && (dateNow < dateVotingClosed);
    return (
      <div>
        <Helmet>
          <title>{pageContent.title}</title>
        </Helmet>
        {!this.state.formSuccess &&
          <section className={style.content}>
            <div className={style.text}>
              <h1>{pageContent.title}</h1>
              {pageContent.intro.intro &&
                <Markdown source={pageContent.intro.intro} softBreak="br" className={style.text} />
              }
              {video &&
                <div className={style.video}>
                  <YoutubeVideo videoUrl={video} />
                </div>
              }
              {pageContent.text.text &&
                <Markdown source={pageContent.text.text} softBreak="br" className={style.text} />
              }
              {image &&
                <div className={style.imageContainer}>
                  <Img className={style.image} fluid={image.fluid} alt="" />
                </div>
              }
              {pageContent.criteria.criteria &&
                <Markdown source={pageContent.criteria.criteria} softBreak="br" className={style.criteria} />
              }
            </div>
          </section>
        }

        {challengeActive &&
          <section className={style.form}>
            {this.state.formSuccess ?
              <div className={style.formSuccess}>
                <h1>{pageContent.formSuccessTitle}</h1>
                {pageContent.formSuccessText.formSuccessText &&
                  <Markdown source={pageContent.formSuccessText.formSuccessText} softBreak="br" className={style.text} />
                }
              </div>
              :
              <div>
                {(typeof window !== `undefined`) &&
                  <ChallengeForm onSuccess={() => this.handleFormSuccess()} />
                }
              </div>
            }
          </section>
        }

        {!this.state.formSuccess &&
          <section id="jury">
            <div className={style.juryContainer}>
              <div className={style.text}>
                {pageContent.juryTitle &&
                  <h1>{pageContent.juryTitle}</h1>
                }
                {pageContent.juryText.juryText &&
                  <Markdown source={pageContent.juryText.juryText} softBreak="br" className={style.text} />
                }
              </div>
            </div>
            <div className={style.juryList}>
              {pageContent.juryMembers &&
                <PersonList persons={pageContent.juryMembers} link={false} />
              }
            </div>
          </section>
        }
      </div>
    )
  }
}

export const ChallengeQuery = graphql`
  query ChallengeQuery {
    page: contentfulChallengePagina {
      id
      title
      metaDescription {
        metaDescription
      }
      text {
        text
      }
      imageActive
      image {
        fluid(maxWidth: 1500) {
          sizes
          src
          srcSet
          srcWebp
          srcSetWebp
          aspectRatio
        }
      }
      videoActive
      video
      formSuccessTitle
      formSuccessText { formSuccessText }
      criteria { criteria }
      intro { intro }
      juryTitle
      juryText {
        juryText
      }
      juryMembers {
        id
        name
        jobtitle
        description
        omschrijving { omschrijving }
        image {
          fluid(maxWidth: 1500) {
            sizes
            src
            srcSet
            srcWebp
            srcSetWebp
            aspectRatio
          }
        }
      }
    }
  }
`